const SkillBar = ({ name, level, index }) => {
  return (
    <div className="skills__item">
      <div className="skills__item-header">
        <span className="skills__name">{name}</span>
        <span className="skills__level">{level}%</span>
      </div>
      <div className="skills__bar">
        <div
          className="skills__bar-fill"
          style={{
            "--width": `${level}%`,
            "--index": index,
          }}
        />
      </div>
    </div>
  );
};

export default SkillBar;
